import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import { setSlecetedActivtyAction } from 'src/Entities/PortalState/PortalState.Actions';

/**
 * TEMPORARY FIX:
 * This route/page component makes it possible to link to a specific course/activity
 * from the app without updating Redux state *explicitly*.
 *
 * NOTE: Please remove this when routing is refactored.
 */

const PATTERN = /^(\d+)-(\d+)-(\d+)$/;

type SetActivityArgs = Parameters<typeof setSlecetedActivtyAction>;

interface ICourseRedirectProps extends RouteComponentProps<{ id: string }> {
  setSelectedActivity: (...args: Parameters<typeof setSlecetedActivtyAction>) => any;
}

const CourseRedirect = ({ match, history, setSelectedActivity }: ICourseRedirectProps) => {
  const ids = React.useMemo(() => {
    const matches = PATTERN.exec(match.params.id);

    if (matches) {
      return [
        matches[1],
        matches[2],
        matches[3]
      ];
    }
    return null;
  }, [match.params.id]);

  React.useEffect(() => {
    if (ids) {
      const [themeId, categoryId, courseId] = ids;
      setSelectedActivity(courseId, themeId, categoryId);
      history.replace(`/kursus/?id=${ids.join('-')}`);
    }
  }, [ids]);

  return null;
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSelectedActivity: (...args: SetActivityArgs) => (
    dispatch(setSlecetedActivtyAction.apply(null, args))
  )
})

export default connect(null, mapDispatchToProps)(CourseRedirect);



// WEBPACK FOOTER //
// ./src/Pages/CourseRedirect.tsx